module.exports = __webpack_public_path__ + "static/media/parceiro(4).cf08f94b.png";